import * as Yup from 'yup';

export const agentFormYupValidation = () => {
  return Yup.object().shape({
    name: Yup.string().required('required'),
    instructions: Yup.string().required('required'),
  });
};
